"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textOverflowsTheSpace = void 0;
var textOverflowsTheSpace = function (logoTextRef) {
    var _a;
    var offsetWidth = 0;
    var scrollWidth = 0;
    var ref = ((_a = logoTextRef.current) === null || _a === void 0 ? void 0 : _a.parentElement)
        ? logoTextRef.current.parentElement.parentElement
        : logoTextRef.current;
    if (ref) {
        offsetWidth = ref ? ref.offsetWidth : 0;
        scrollWidth = ref ? ref.scrollWidth : 0;
    }
    return offsetWidth < scrollWidth;
};
exports.textOverflowsTheSpace = textOverflowsTheSpace;
